<template>
  <div class="component-observer">
    <slot v-if="intoView"></slot>
  </div>
</template>

<script>
export default {
  name: 'ComponentObserver',
  props: {
    delay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      intoView: false
    }
  },
  methods: {
    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.intoView = true
            observer.unobserve(entry.target)
          }
        })
      }, {
        rootMargin: `${ window.innerHeight / 1.5 }px`
      });

      observer.observe(this.$el)
    }
  },
  mounted() {
    if (window.location.search.includes('ga-isr=yes')) {
      this.intoView = true
    }
    else {
      if (this.delay) {
        setTimeout(() => {
          this.createObserver()
        }, 300);
      }
      else {
        this.createObserver()
      }
    }
  }
}
</script>

<style>
.component-observer {
  min-height: 50vh;
}
</style>